import { useMemo } from 'react';
import FlexPane from 'presentation/components/flex-pane/index.js';
import Text from 'presentation/components/text/index.js';
import CompetitorIcon from 'presentation/components/competitor-icon/index.js';
import { useCompetitorsIconsQuery } from 'presentation/components/competitor-icon/hooks/index.js';
import { sortParticipants } from 'presentation/components/scoreboard/utils.js';

const ParticipantIconsInline = props => {
    const {
        participants,
        sportId,
        homeAway,
        separator,
        mojitoTools: { config },
    } = props;

    const { showParticipantIcons: showIcons } = config.participantIcons || {};
    const showNames = config.showParticipantNames;

    const sortedParticipants = useMemo(
        () => sortParticipants(participants, homeAway),
        [participants, homeAway]
    );
    const competitors = useMemo(
        () => sortedParticipants.map(participant => ({ ...participant, sportId })),
        [sortedParticipants, sportId]
    );
    // Resolving icons hits the network for competitors whose icon is not in config, so skip it
    // entirely when the icons are not rendered.
    const { competitorsWithIcons } = useCompetitorsIconsQuery({
        competitors,
        config: showIcons ? config.competitorIconOptions : undefined,
    });

    const [firstCompetitor, secondCompetitor] = competitorsWithIcons;

    if (!firstCompetitor || !secondCompetitor) {
        return null;
    }

    return (
        <FlexPane config={config.container} class="ta-ParticipantIconsInline">
            {showNames && (
                <Text class="ta-firstParticipantName" config={config.participantName}>
                    {firstCompetitor?.name}
                </Text>
            )}
            {showIcons && (
                <CompetitorIcon
                    config={config.participantIcon}
                    title={firstCompetitor?.name}
                    src={firstCompetitor?.iconSrc}
                />
            )}
            <Text class="ta-separator" config={config.separator}>
                {separator}
            </Text>
            {showIcons && (
                <CompetitorIcon
                    config={config.participantIcon}
                    title={secondCompetitor?.name}
                    src={secondCompetitor?.iconSrc}
                />
            )}
            {showNames && (
                <Text class="ta-secondParticipantName" config={config.participantName}>
                    {secondCompetitor?.name}
                </Text>
            )}
        </FlexPane>
    );
};

export default ParticipantIconsInline;
